import React from 'react';
import { t } from 'i18next';
import CustomMiniCard from '../../../../components/CustomMiniCard';
import NotInformation from '../../../../components/NotInformation';
import { statusColor } from '../../../../enums/statusColorEnum';
import { getDateFormat } from '../../../../Apis/functions';
import { status } from '../../../../enums/statusEnum';
import RowCardText from '../../../../components/RowCardText';
import CustomChip from '../../../../components/CustomChip';

const IncomingEvents = ({ list, userDataTransformHost, userDataTransformValidatedBy }) => {

    return (<>
        {list?.length > 0 ?
            <>
                {list?.map((event) => {
                    return (
                        <CustomMiniCard>
                            <div className='px-0 d-flex justify-content-between'>
                                <div className='ibl-item-description-green'>{`${t('Folio')} # ${event?.folio || '-'}`}</div>

                                <CustomChip
                                    background={statusColor[event?.statusId]}
                                    legend={t(status[event?.statusId]).toUpperCase() || '-'}
                                />

                            </div>

                            <div className='ibl-item-description-green'>{t('information')}</div>
                            <RowCardText title={t('name')} value={event?.name || '-'} />
                            <RowCardText title={t('host')} value={userDataTransformHost([event])[0].label} />
                            <RowCardText title={t('start_date')} value={getDateFormat(event.startDate, true)} />
                            <RowCardText title={t('end_date')} value={getDateFormat(event.endDate, true)} />
                            <RowCardText title={t('booking')} value={event?.reservationZoneName || '-'} />
                            <RowCardText title={t('validated_by')} value={event?.validatedById === null ? '-' : userDataTransformValidatedBy([event])[0].label} />

                        </CustomMiniCard>
                    );
                })}
            </>
            :
            <NotInformation text={t('no_information')} card={true} />
        }
    </>);
}

export default IncomingEvents;
